/**
 * My Work change nudges: /me/work/events pings whenever something in the
 * caller's account moves a My Work counter (timesheet/correction lifecycle,
 * service assignment, mentions). Consumers re-fetch the /me/work aggregate
 * on receipt; see useNudgeSSE for the channel's guarantees (a hint only —
 * keep the focus/foreground refetch as the source of truth).
 */
import { useNudgeSSE } from './useNudgeSSE';
export function useMyWorkSSE(options) {
    return useNudgeSSE({ ...options, path: '/me/work/events', changeType: 'my_work_changed', logPrefix: '[MyWork SSE]' });
}
